import React from "react";

const GetFont = ({canUndo, onClick}) => {
  return (
    <svg width="16" height="16" role="img" aria-label="Get Font" viewBox="0 0 16 16" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.803 2.80268C9.0959 2.50978 9.57077 2.50978 9.86366 2.80268L14.5303 7.46934C14.8232 7.76224 14.8232 8.23711 14.5303 8.53L9.86366 13.1967C9.57077 13.4896 9.0959 13.4896 8.803 13.1967C8.51011 12.9038 8.51011 12.4289 8.803 12.136L12.1893 8.74967H2C1.58579 8.74967 1.25 8.41389 1.25 7.99967C1.25 7.58546 1.58579 7.24967 2 7.24967H12.1893L8.803 3.86334C8.51011 3.57044 8.51011 3.09557 8.803 2.80268Z" fill="#1A73E8"/>
    </svg>
  );
};

export default GetFont;
